import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { inherits } from 'util';

export const styles = (theme: Theme) => createStyles({
	headerActions: {
		textAlign: 'right',
		marginLeft: '-57px'
	},
	vertHeaderActions: {
		textAlign: 'center',
		marginLeft: '-8px'
	},
	createContentButton: {
		marginRight: theme.spacing.unit * 4,
	},
	headerTitle: {
		textAlign: 'center',
		marginLeft: '-6px'
	}, root: {
		flexShrink: 0,
		color: theme.palette.text.secondary,
	},
	iconButton: {
		padding: theme.spacing.unit / 4
	},
	progress: {
		margin: theme.spacing.unit * 2,
	},
	leftDisplay: {
		marginLeft: theme.spacing.unit * 4,
	},
	textBar: {
		textAlign: "center"
	},
	subScriptFont: {
		fontSize: "12px"
	},
	textSize: {
		fontSize: '14px'
	},
	textBold: {
		fontWeight: 'bold'
	},
	textEllipsis: {
		width: '100%',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		paddingRight: theme.spacing.unit
	},
	subTitle: {
		display: 'inline-block',
		lineHeight: theme.spacing.unit * 3 + "px",
	},
	linearProgressBox: {
		height: '35px',
		width: '370px',
		border: '1px solid #DDDDDD',
		borderRadius: '30px',
		marginTop: '40px',
		paddingLeft: '6px',
		paddingRight: '6px',
		fontSize: '10px',
	},
	linearProgressBar: {
		marginTop: '-12px',
		width: '148px',
		marginLeft: '0px'
	},
	previewButton: {
		background: theme.palette.common.white,
		border: '1px solid #DDDDDD',
		fontWeight:'normal',
		width:'93px',
		boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.0519701)',
		padding: theme.spacing.unit,
		opacity: 0.7,
		'& svg': {
			marginRight: theme.spacing.unit
		}
	},
	viewDetails: {
		opacity: 0.7,
		fontSize: '14px',
		paddingLeft: '12px',
		color: theme.palette.text.secondary
	},
	previewBtn: {
		float: 'right',
		marginTop:'-20px'
	},
	textValue: {
		margin: '5px 5px 0px',
	},
	icon: {
		margin: '-4px 147px 0px',
		fontSize: '18px'
	},
	wrapperMain: {
		height: "auto", backgroundColor: theme.palette.common.white, paddingRight: "20px", paddingLeft: "20px", fontSize: "18px"
	},
	borderDefault: {
		border: "1px solid #DDDDDD",
		borderRadius: "5px",
		marginTop:"10px"
	},
	marginTop10: {
		marginTop: theme.spacing.unit
	},
	searchWrapper: {
		paddingTop: "15px",
		paddingLeft: "10px",
		paddingRight: "10px",
		paddingBottom: "15px",
	},
	link: { fontSize: "12px", color: "#2196F3", marginBottom: "20px" },
	chipStyle:
		{ float: "left", padding: "10px", margin: "7px", borderRadius: "40px", border: "1px solid #DFDFDF", backgroundColor: "#DFDFDF", marginTop: "19px" },
	checkboxCSS: {
		color: "#4CAF50",
		'&$checked': {
			color: "#43A047",
		},
	},
	circle:{
		width: "25px",
		height:"25px",
		right:"-17px",
		top:"12px",
		position:"relative",
		borderRadius:"50%",
		fontSize:"15px",
		fontStyle:"inherit",
		color:"#fff",
		lineHeight:"25px",
		textAlign:"center",
		background: "#f50057"
	},
	checked: {},

});